<div
  class="flex flex-col gap-9 mt-8"
  *ngIf="!loading() && projectDetail()">
  <div class="flex items-center justify-between">
    <app-back-button />
    <app-buttons
      *ngIf="canCurrentUserAccessReview()"
      [label]="reviewButtonLabel"
      [classes]="'text-primary-base'"
      (click)="goToReview()" />
    <app-buttons
      *ngIf="canCurrentUserCorrect()"
      [label]="'Subsanar proyecto'"
      [classes]="'text-primary-base'"
      (click)="goToCorrection()" />
  </div>

  <div class="text-4xl font-bold">{{ projectDetail()?.projectName || '-' }}</div>
  <div class="flex items-center gap-3">
    <div
      class="w-4 h-4"
      [ngClass]="colorBox()"></div>
    <div class="text-md font-semibold">{{ stateTextFormat() }}</div>
    <span class="text-md text-neutral-dark">
      Creado el {{ projectDetail()?.creationDate || '-' }}, por {{ projectDetail()?.creationUser || '-' }}
    </span>
  </div>

  <app-review-states
    *ngIf="projectDetail()?.state !== 'REJECTED'"
    [context]="'project'"
    [stateGroups]="stateGroup"
    [activeStage]="activeStage"
    [projectState]="projectDetail()?.state"
    [showReviewButton]="canCurrentUserReview()"
    [reviewButtonLabel]="reviewStatesButtonLabel"
    [onReview]="goToReview.bind(this)"></app-review-states>

  <app-project-identification-data [project]="projectDetail()" />
  <app-project-functional-data [project]="projectDetail()" />
  <app-project-economic-data [project]="projectDetail()" />
  <app-project-input-data [project]="projectDetail()" />
  <app-project-risk-data [project]="projectDetail()" />

  <app-project-ai-systems [project]="projectDetail()" />
</div>
